<template>
  <div class="popularize">
    <div class="popularize-code">
      <div class="popularize-code-number">
        <img class="popularize-code-number-img" src="../../assets/image/QzpcG5n.png" alt />
        <p>加入我们，付款得返利</p>
        <div class="home-congratulation">
          <div>
            <van-cell-group class="home-congratulation-from">
              <van-field
                @click="$refs.phone.focus()"
                name="private_phone"
                type="tel"
                ref="phone"
                onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                pattern="(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$"
                keyboardType="UIKeyboardTypeDecimalPad;"
                v-model="phone"
                maxlength="11"
                placeholder="请输入手机号"
              />
              <div>
                <van-field
                  @click="$refs.verifycode.focus()"
                  ref="verifycode"
                  type="tel"
                  onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                  keyboardType="UIKeyboardTypeDecimalPad;"
                  v-model="verifycode"
                  maxlength="6"
                  center
                  clearable
                  placeholder="请输入验证码"
                />
                <van-button
                  color="#2480FF"
                  class="home-congratulation-from-button"
                  @click="sendVerifycode()"
                  type="primary"
                  round
                  :disabled="!disabledCodeBtn"
                >{{codeText}}</van-button>
              </div>
              <div>
                <van-button
                  color="#2480FF"
                  slot="button"
                  type="primary"
                  round
                  block
                  @click="login()"
                  native-type="submit"
                >立即加入</van-button>
              </div>
            </van-cell-group>
          </div>
        </div>
      </div>
      <p class="home-congratulation-last-child">查看收益，关注微信公众号“开三汇”</p>
      <img src="../../assets/image/lADP.jpg" alt />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
// import { createUser } from "../../api/generalize/generalize";
import { request } from "@/utils/https";
import { setUserToken } from "@/utils/Cookie";

export default {
  name: "popularize",

  data() {
    return {
      phone: "",
      verifycode: "",
      codeText: "获取验证码",
      disabledCodeBtn: true,
      utoken: "",
      token: ""
    };
  },
  created() {
    if (this.$route.query.utoken) {
      this.utoken = this.$route.query.utoken;
    }
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
    }
    if (this.GetQueryString("utoken")) {
      this.utoken = this.GetQueryString("utoken");
    }
    if (this.GetQueryString("token")) {
      this.token = this.GetQueryString("token");
    }
  },
  methods: {
    GetQueryString(name) { //url参数接收截取
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    // 向后台要验证码方法
    async sendVerifycode() {
      if (this.verifyPhone()) {
        Toast(this.verifyPhone());
      } else {
        let data = {
          phone: this.phone
        };
        let res = await request("user/sms/sendSms", data);
        if (res.error == 0) {
          this.countDown(60);
        } else {
          Toast(res.error_reason);
        }
        //  用手机号向后台换取验证码，发送成功则开始调用倒计时分方法
      }
    },
    // 表单校验方法
    verifyPhone() {
      if (!this.phone) {
        return "请输入手机号";
      } else if (this.phone.length !== 11) {
        return "请输入11位手机号";
      } else {
        return false;
      }
    },
    // 倒计时方法
    countDown(time) {
      if (time === 0) {
        this.disabledCodeBtn = true;
        this.codeText = "获取验证码";
        return;
      } else {
        this.disabledCodeBtn = false;
        this.codeText = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },

    async login() {
      if (this.verifyPhone()) {
        Toast(this.verifyPhone());
      } else if (this.verifycode == "") {
        Toast("请输入验证码");
      } else {
        // let _this = this
        let list = {
          phone: this.phone,
          code: this.verifycode
        };
        let res = await request("user/sms/verificationSmsCode", list);
        if (res.error == 0) {
          let data = {
            mobile: this.phone,
            utoken: this.utoken,
            token: this.token
          };
          let red = await request("user/test/createUser", data);
          if (red.error == 0) {
            console.log(red);
            setUserToken(red.data.token);
            this.$router.push({
              path: "promotion"
            });
            Toast(red.data.message);
          } else {
            Toast(red.error_reason);
          }
        } else {
          Toast(res.error_reason);
        }
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.popularize {
  width: 100%;
  height: 100%;
  position: absolute;
  background: url("../../assets/image/bg-big.png");
  background-size: 100% 100%;
  .popularize-code {
    padding: 1.59375rem 1.09375rem 2rem 1.09375rem;
    text-align: center;
    .popularize-code-number {
      padding: 0.9375rem 1.25rem 1.59375rem 1.25rem;
      background: #fff;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.5rem;
      .popularize-code-number-img {
        width: 8.75rem;
        height: 2.875rem;
      }
      p {
        padding-top: 0.9375rem;
        padding-bottom: 0.75rem;
        font-size: 1rem;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }

      .home-congratulation {
        background-color: #fff;

        div:first-child {
          text-align: center;

          p:first-child {
            padding-bottom: 0.78125rem;
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(36, 128, 255, 1);
          }
          p:last-child {
            font-size: 1.3125rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 192, 0, 1);
          }
        }
        div:last-child {
          .home-congratulation-from {
            .van-cell {
              height: 2.8125rem;
              padding-bottom: 0.6rem;
              background: rgba(242, 242, 242, 1);
              border-radius: 45px;
            }
            div:nth-child(2) {
              margin-top: 1.25rem;
              display: flex;
              justify-content: center;
              .van-cell {
                margin: 0;
              }
              .van-field__body {
                margin-top: 15px;
              }
              .home-congratulation-from-button {
                margin-left: 0.6rem;
                width: 13.8125rem;
                height: 2.8125rem;
                background: rgba(36, 128, 255, 1);
                border-radius: 1.40625rem;
                font-size: 1rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);

                .van-button__content {
                  margin-top: 0;
                }
              }
            }
            div:nth-child(3) {
              margin-top: 2rem;
            }
          }
        }
      }
    }
    .home-congratulation-last-child {
      padding-top: 1.875rem;
      padding-bottom: 0.84375rem;
      font-size: 1rem;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    img:last-child {
      width: 9.75rem;
      height: 9.75rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;
    }
  }
}
.popularize
  .popularize-code
  .popularize-code-number
  .home-congratulation
  div:last-child
  .home-congratulation-from
  div:nth-child(2)
  .home-congratulation-from-button[data-v-407945b4] {
  margin-left: 0.4rem;

  width: 13.8125rem;
  height: 2.8125rem;
  background: #2480ff;
  border-radius: 1.40625rem;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: white;
}
</style>
